import clsx from 'clsx';
import { Button } from 'src/components/Button';
import useAuthedRequest from 'src/hooks/useAuthedRequest';
import { OnboardingComponent } from 'src/interfaces/onboardingComponent.interface';

export const Ready = ({
  onPhaseComplete,
  organization,
  secondaryAction,
}: OnboardingComponent) => {
  const { patch } = useAuthedRequest();

  const backButton = async () => {
    if (!secondaryAction) return;

    await patch(`/organizations/${organization.id}/onboarding`, {
      currentPhase: 'welcome',
      isCompleted: false,
    });

    secondaryAction();
  };

  const continueButton = async () => {
    await patch(`/organizations/${organization.id}/onboarding`, {
      currentPhase: 'ready',
      isCompleted: true,
    });
    onPhaseComplete();
  };

  return (
    <>
      <img
        src="/assets/logo-white.png"
        alt="Circle"
        className={clsx('absolute top-10 left-10 h-10 animate-fade-in-up')}
      />
      <div className="container mx-auto py-10">
        <div className="flex flex-col items-center justify-center min-h-[80vh] p-8 animate-fade-in">
          <img
            src="/assets/onboarding/circle.png"
            alt="Circle Chat"
            className="w-16 h-16 mb-4 animate-fade-in-up"
          />

          <div className="text-[40px] font-normal mb-2 text-center text-neutral-0 animate-fade-in-up">
            I think you're ready to uncover more at Fluents.
          </div>

          <div className="w-screen absolute bottom-0 left-0 bg-neutral-700 p-4 flex flex-col md:flex-row md:justify-end gap-6">
            <Button
              variant="outlined"
              className="px-4 py-3 min-w-[96px] bg-neutral-0"
              size="small"
              onClick={backButton}
            >
              Back
            </Button>

            <Button onClick={continueButton} className="px-4 py-3 min-w-[96px]">
              Continue
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
